export default "/_next/static/media/Screen-Shot-2021-02-20-at-3.57.36-PM-1-599x1024.2255bc490970c103eb05968fa9e46c30.png";